<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="25%"
    center
    class="Dialog"
    title="打印类型"
  >
    <div class="dialog-content">
      <el-select v-model="value" placeholder="请选择打印类型">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="printHandler"
          >确定打印</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  // , tableList

  export default {
    props: {},
    data() {
      return {
        load: false,
        options: [
          {
            value: 'excel',
            label: 'EXCEL',
          },
          {
            value: 'pdf',
            label: 'PDF',
          },
        ],
        value: '',
        visible: false,
      };
    },

    mounted() {},
    methods: {
      openDialog() {
        this.visible = true;
      },
      printHandler() {
        if (!this.value) {
          this.$message.error('打印类型不能为空');
          return;
        }
        this.$emit('printHandler', this.value);
        this.visible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
  }
  .dialog-content {
    display: flex;
    justify-content: center;
  }
</style>
